module.exports = __webpack_public_path__ + "static/media/cartinina.e2586d9e.svg";